<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="this.arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="row mt-3">
  <div class="col">
    <mat-form-field class="mr-5" class="field-filtre">
      <mat-label>Filtrer</mat-label>
      <input matInput #input [value]="filterInputValue()" (input)="onFilterInput($event)" (keyup)="appDataTable.applyFilter($event)" />
      @if (filterInputValue().length > 0) {
        <button mat-icon-button matSuffix aria-label="Effacer le filtre" (click)="clearFilter(input)" type="button">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <div class="col flex-container end align-items-center">
    <div>
      <button mat-stroked-button class="bt-table-defaut mr-5" (click)="exportParametre()"><mat-icon>download</mat-icon>Exporter</button>
    </div>
    <div>
      <button mat-raised-button class="bt-table-defaut bt-table-ajouter mr-5" (click)="importParameterData()">
        <mat-icon>upload</mat-icon> Importer
      </button>
    </div>
  </div>
</div>
<app-data-table
  #appDataTable
  [displayedColumns]="ParametresDisplayedColumns"
  [data]="dataTable"
  [expendable]="false"
  [hasView]="false"
  [editable]="true"
  [historical]="true"
  [delatable]="false"
  [filter]="false"
  (clicModalModifier)="modifParametre($event)"
  (fetchData)="retrieveHistory($event)"
  [length]="dataLength"
  (updatePagination)="updatePaginationParametres($event)"
  (updateFiltre)="updateFiltreParametre($event)"
  [customFilter]="true"
></app-data-table>
